import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Ban, CheckIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import Container from "../Container";
import { Label } from "./label";
import Text from "../Text";
import { AppTheme } from "@/utils/constants/theme";

export type CheckboxProps = Omit<
  React.ComponentProps<typeof CheckboxPrimitive.Root>,
  "id"
> & {
  id: string | number;
  label?: string;
  err?: string;
};

function Checkbox({
  className,
  label,
  id,
  err,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & CheckboxProps) {
  return (
    <>
      <Container
        indention={0}
        flexDisplay
        direction="row"
        itemsAlign="center"
        gap={5}
      >
        <CheckboxPrimitive.Root
          id={id}
          data-slot="checkbox"
          className={cn(
            "peer border-[#CFCFCF] data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
            className,
          )}
          {...props}
        >
          <CheckboxPrimitive.Indicator
            data-slot="checkbox-indicator"
            className="flex items-center justify-center text-current transition-none"
          >
            <CheckIcon className="size-4" />
          </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
  {label && <Label htmlFor={id} className="!text-[12px]">{label}</Label>}
      </Container>{" "}
      {!!err && (
        <Container
          indention={0}
          flexDisplay
          direction="row"
          itemsAlign="center"
          gap={5}
        >
          <Ban size="14px" color={AppTheme.darkBurgundy} />
          <Text size="xs" color={AppTheme.darkBurgundy}>
            {err}
          </Text>
        </Container>
      )}
    </>
  );
}

export { Checkbox };
